const PlusIcon = ({ className }) => (
  <svg className={className} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 5L-2.98023e-07 5" stroke="currentColor" strokeWidth="2" />
    <path d="M5 10L5 -2.98023e-07" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default PlusIcon;
